<template>
  <div>
    <v-dialog
      v-model="display"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      persistent
      width="800px"
      max-height="600px"
      scrollable
    >
      <v-card class="mx-auto secondary">
        <CardHeader title="BRUGER" icon="mdi-close" @iconClicked="cancel" />
        <div class="px-2">
          <v-form ref="userForm" v-model="userValid" lazy-validation>
            <v-row class="pa-0 pt-2 ma-0" no-gutters>
              <v-col
                :cols="this.$vuetify.breakpoint.smAndDown ? 12 : 6"
                class="pr-2"
              >
                <v-text-field
                  v-model="firstName"
                  type="text"
                  label="Fornavn"
                  :rules="[rules.firstName.required]"
                  clearable
                  outlined
                  dense
                  color="primary"
                  background-color="white"
                  class="rounded-0"
                />
              </v-col>
              <v-col
                :cols="this.$vuetify.breakpoint.smAndDown ? 12 : 6"
                class="pr-2"
              >
                <v-text-field
                  v-model="lastName"
                  type="text"
                  label="Efternavn"
                  :rules="[rules.lastName.required]"
                  clearable
                  outlined
                  dense
                  color="primary"
                  background-color="white"
                  class="rounded-0"
                />
              </v-col>
            </v-row>
            <v-row class="pa-0 pt-2 ma-0" no-gutters>
              <v-col
                :cols="this.$vuetify.breakpoint.smAndDown ? 12 : 6"
                class="pr-2"
              >
                <v-text-field
                  v-model="email"
                  type="text"
                  label="E-mail"
                  :rules="[rules.email.required]"
                  clearable
                  outlined
                  dense
                  color="primary"
                  background-color="white"
                  class="rounded-0"
                />
              </v-col>
            </v-row>
            <v-row class="pa-0 py-2 ma-0" no-gutters>
              <v-col
                :cols="this.$vuetify.breakpoint.smAndDown ? 12 : 6"
                class="pr-2"
              >
                <v-text-field
                  v-model="phone"
                  type="text"
                  label="Telefon"
                  :rules="[rules.phone.required]"
                  clearable
                  outlined
                  dense
                  color="primary"
                  background-color="white"
                  class="rounded-0"
                />
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row class="pa-0 pt-2 ma-0" no-gutters>
              <v-col
                :cols="this.$vuetify.breakpoint.smAndDown ? 12 : 6"
                class="pr-2"
              >
                <v-text-field
                  v-model="userName"
                  type="text"
                  label="Brugernavn"
                  :rules="[rules.userName.required]"
                  clearable
                  outlined
                  dense
                  color="primary"
                  background-color="white"
                  class="rounded-0"
                />
              </v-col>
            </v-row>
            <v-row class="pa-0 py-2 ma-0" no-gutters v-show="showPassword">
              <v-col
                :cols="this.$vuetify.breakpoint.smAndDown ? 12 : 6"
                class="pr-2"
              >
                <PasswordTemplate
                  @passwordUpdated="
                    updatedPassword => (password = updatedPassword)
                  "
                />
              </v-col>
            </v-row>
          </v-form>
        </div>
        <v-card-actions>
          <v-spacer />
          <v-btn text class="text-left" @click="cancel()">
            FORTRYD
          </v-btn>

          <v-btn class="text-right" @click="submit()">
            GEM
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="displayResult"
      :color="
        resultError
          ? this.$vuetify.theme.themes.light.error
          : this.$vuetify.theme.themes.light.success
      "
    >
      {{ resultText }}
    </v-snackbar>
  </div>
</template>

<script>
import PasswordTemplate from "@/components/templates/PasswordTemplate.vue";
import CardHeader from "@/components/templates/CardHeader.vue";

export default {
  name: "UserDialog",
  components: {
    CardHeader,
    PasswordTemplate
  },
  props: {
    display: { type: Boolean, required: true },
    user: { type: Object, required: true }
  },
  data() {
    return {
      userValid: false,
      rules: {
        userName: {
          required: v => !!v || false
        },
        firstName: {
          required: v => !!v || false
        },
        lastName: {
          required: v => !!v || false
        },
        email: {
          required: v => !!v || false
        },
        phone: {
          required: v => !!v || false
        }
      },
      password: "",
      displayResult: false,
      resultError: false,
      resultText: ""
    };
  },
  computed: {
    mutableUser() {
      return Object.assign({}, this.user); //clone
    },
    userName: {
      get() {
        return this.mutableUser.user_name;
      },
      set(value) {
        this.mutableUser.user_name = value;
      }
    },
    firstName: {
      get() {
        return this.mutableUser.first_name;
      },
      set(value) {
        this.mutableUser.first_name = value;
      }
    },
    lastName: {
      get() {
        return this.mutableUser.last_name;
      },
      set(value) {
        this.mutableUser.last_name = value;
      }
    },
    email: {
      get() {
        return this.mutableUser.email;
      },
      set(value) {
        this.mutableUser.email = value;
      }
    },
    phone: {
      get() {
        return this.mutableUser.phone;
      },
      set(value) {
        this.mutableUser.phone = value;
      }
    },
    showPassword() {
      return this.mutableUser.id === -1;
    }
  },
  methods: {
    cancel() {
      this.disposeDialog();
    },
    async submit() {
      this.$refs.userForm.validate();
      if (
        this.userValid &&
        this.mutableUser &&
        this.mutableUser.user_name != "" &&
        this.mutableUser.first_name != "" &&
        this.mutableUser.last_name != "" &&
        this.mutableUser.email != "" &&
        this.mutableUser.phone != ""
      ) {
        const user = this.mutableUser;
        const password = this.password;

        await this.$store.dispatch("user/updateUser", { user, password }).then(
          response => {
            (this.displayResult = true), (this.resultText = response);
            this.resultError = false;
          },
          error => {
            console.error(error);
            (this.displayResult = true), (this.resultText = error);
            this.resultError = true;
          }
        );
        this.disposeDialog();
      }
    },
    disposeDialog() {
      this.$refs.userForm.reset();
      this.$emit("disposeDialog");
    }
  }
};
</script>
